import React from "react";
import { Card, Button } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		background: theme.mode === 'dark'
			? "rgba(15,20,30,0.97)"
			: "#ffffff",
		flex: "none",
		borderBottom: theme.mode === 'dark'
			? "1px solid rgba(255,255,255,0.06)"
			: "1px solid rgba(0,0,0,0.07)",
		boxShadow: theme.mode === 'dark'
			? "0 2px 8px rgba(0,0,0,0.3)"
			: "0 2px 8px rgba(0,0,0,0.05)",
		minHeight: "64px",
		padding: "0 4px",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "nowrap",
			minHeight: 56,
			height: "auto",
			overflow: "hidden",
		},
	},
	backButton: {
		minWidth: 36,
		padding: "6px 4px",
		color: theme.palette.primary.main,
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const handleBack = () => {
		history.push("/tickets");
	};

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card square className={classes.ticketHeader}>
					{isMobile && (
						<Button color="primary" className={classes.backButton} onClick={handleBack}>
							<ArrowBackIos fontSize="small" />
						</Button>
					)}
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
